module.exports = __webpack_public_path__ + "img/charge_car2.5e57b49e.png";